import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { PortRow } from './templates/PortRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
};
export const CoilDiameterRow = ({ manifold }: Props) => {
  return <PortRow name="Coil Diameter (mm)" manifold={manifold} getValue={room => room.pipeDiameterInMillimetres} />;
};
